import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeader({ title, subtitle, crumbs = [], actions }) {
  return (
    <div className="page-header">
      <div>
        {crumbs.length > 0 && (
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            {crumbs.map((c, i) =>
              c.to ? (
                <React.Fragment key={i}>
                  <span className="sep">/</span>
                  <Link to={c.to}>{c.label}</Link>
                </React.Fragment>
              ) : (
                <React.Fragment key={i}>
                  <span className="sep">/</span>
                  <span>{c.label}</span>
                </React.Fragment>
              )
            )}
          </div>
        )}
        <h1 className="page-title">{title}</h1>
        {subtitle && <div className="page-subtitle">{subtitle}</div>}
      </div>
      {actions && <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}